<section class="facet-filter">
  <h3 class="facet-subtitle" attr.aria-label="{{ 'adura.search.title.public' | translate }}">{{ 'adura.search.title.public' | translate }}</h3>
  <div>
    <ng-container *ngIf="!this.isPublic || this.isPublic.length === 0">
      <p><small>{{ 'search.noFilter' | translate }}</small></p>
    </ng-container>
    <nav [attr.aria-label]="'document.status.list' | translate">
      <div class="list-inline tags">
        <ng-container *ngFor="let state of isPublic">
          <div class="flex-container">
            <input type="checkbox" class="filter-checkbox sr-only" id="is_public_{{state.id}}"
                   (click)="changeIsPublic('is_public_' + state.id)"
                   [checked]="isPublicActive(state.id)">
            <label class="filter-checkbox-label" [ngClass]="(state.count === 0)?'filter-element-background':''"
                   for="is_public_{{state.id}}"
                   role="checkbox"
                   [attr.aria-label]="('adura.status.label' | translate) + ': ' + (state.name | translate) + ', ' +
                   ('global.total' | translate) + ': ' + state.count"
                   [attr.aria-checked]="(isPublicActive(state.id))?'true':'false'">
              {{ 'global.boolean.' + state.name | translate }}
            </label>
            <span class="filter-checkbox-number" aria-hidden="true">{{ state.count}}</span>
          </div>
        </ng-container>
      </div>
    </nav>
  </div>
</section>
